export const NUMBER_PLACEHOLDER = "+7 (___) ___-__-__";

export const NOT_FOUND_PLACEHOLDER = "Страница не найдена :(";
